import React from 'react';
import PropTypes from 'prop-types';

class XAxis extends React.Component {
    static propTypes = {
        chartBoundaries: PropTypes.object.isRequired,
        xValueToSVGCoordinateMapper: PropTypes.func.isRequired,
        xValueFormatFunction: PropTypes.func.isRequired,
    }

    static defaultProps = {
        xValueFormatFunction: (value) => (value),
    }

    render() {
        const {
            chartBoundaries,
            xValueToSVGCoordinateMapper,
            xValueFormatFunction,
        } = this.props;

        let tickPadding = 15;
        let tickValues = (xValueToSVGCoordinateMapper.ticks && xValueToSVGCoordinateMapper.ticks()) || xValueToSVGCoordinateMapper.domain();

        let calculateX = function(value) {
            let X = xValueToSVGCoordinateMapper(value);
            if (!X && X!==0) {
                throw new Error('X value was not in expected set of x values');
            }
            if (xValueToSVGCoordinateMapper.bandwidth) {
                X += xValueToSVGCoordinateMapper.bandwidth() / 2;
            };
            return X;
        };


        return (
            <g
                className={'xaxis'}
            >
                {
                    tickValues.map((value, index) => {
                        return (
                            <text
                                className={'xaxis-label'}
                                style={{'textAnchor': 'middle', 'dominantBaseline': 'central'}}
                                stroke='#000'
                                y={chartBoundaries.bottom+tickPadding}
                                x={calculateX(value)}
                                key={index}
                            >
                                {xValueFormatFunction(value)}
                            </text>
                        );
                    })
                }

            </g>
        );
    }
};

export default XAxis;
